import SocialButton from "../components/SocialButton";
import bskyIcon from "../img/misc/socials/bsky.svg";
import tumblrIcon from "../img/misc/socials/tumblr.svg";
import instagramIcon from "../img/misc/socials/instagram.svg";
import telegramIcon from "../img/misc/socials/telegram.svg";
import cats from "../img/misc/thecats.jpg";

const SOCIALS = [
    {
        link: "https://bsky.app/profile/saltmalk.in",
        style: "bsky",
        icon: bskyIcon,
        alt: "bsky",
    },
    {
        link: "https://saltmalkin.tumblr.com/",
        style: "tumblr",
        icon: tumblrIcon,
        alt: "tumblr"
    },
    {
        link: "https://www.instagram.com/saltmalkin/",
        style: "instagram",
        icon: instagramIcon,
        alt: "instagram"
    },
    {
        link: "https://t.me/saltmalkin",
        style: "telegram",
        icon: telegramIcon,
        alt: "telegram"
    }
];

export default function Contact() {
    return (
        <div id="contact" className="center slim">
            <h2>
                Contact Me
            </h2>
            <p>
                For any questions or work inquiries, please email me at:
            </p>
            <a
                href="mailto:saltmalkin@gmail.com"
                className="email"
                target="_blank"
                rel="noopener noreferrer"
            >
                saltmalkin@gmail.com
            </a>
            <br />
            <h2>
                About Me
            </h2>
            <p className="center">
                Laney Sang is often found drawing plenty of cats and some non-cats.
            </p>
            <p className="center">
                She explores the animal through the lens of familiar forms and nostalgic spaces. Her work has been featured in video games, books, posters, and murals. More recently, she can be found working independently on local shows and spaces in the PNW.
            </p>
            <p className="center" style={{display: "inline"}}>
                She lives in Seattle, waiting out the rain with her two cats <a href={cats} target="_blank" className="cats">Azzy and Lily</a>.
            </p>
            <br />
            <h2>Socials</h2>
            <div className="socials">
                {SOCIALS.map((social, index) => (
                    <SocialButton
                        key={index}
                        link={social.link}
                        icon={social.icon}
                        alt={social.alt}
                    />
                ))}
            </div>
        </div>
    )
}